<template>
  <div class="text-center rounded mt-2" :style="{'background-color':logo_auth_color}">
    <img alt="Auth logo" class="img-fluid" src="../assets/logoauth.png">
  </div>    
</template>

<script>
export default {
  name: 'LogoAuth',
  data() {
    return {
      logo_auth_color: process.env.VUE_APP_LOGO_AUTH_COLOR,
    };
  },
}
</script>
